module.exports = __webpack_public_path__ + "img/complete_content.927b220f.png";